import React, { useEffect, useMemo, useState } from 'react';

const normalizarFilas = (reports) => {
  if (!Array.isArray(reports)) return [];

  const arrays = reports.filter(Array.isArray);
  if (arrays.length > 0) {
    const filas = arrays.find((item) => item.length > 0);
    return filas || arrays[0] || [];
  }

  return reports.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
};

const formatearComprobante = (row) => {
  const serie = row?.SerieComprobante || '';
  const numero = row?.NumeroComprobante || row?.NumComprobante || '';
  if (serie && numero) return `${serie} - ${numero}`;
  return numero || '-';
};

const MisReportes = () => {
  const [fechaConsulta, setFechaConsulta] = useState(() => {
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, '0');
    const dd = String(hoy.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  });
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [filas, setFilas] = useState([]);

  const cargarReportes = async () => {
    setCargando(true);
    setError(null);

    try {
      const params = new URLSearchParams();
      if (fechaConsulta) params.append('fechaConsulta', fechaConsulta);

      const response = await fetch(`/api/despacho/reportes?${params.toString()}`);
      const data = await response.json();

      if (!data || data.success !== true) {
        setFilas([]);
        setError(data?.message || 'No se pudieron cargar los reportes');
        return;
      }

      const rows = normalizarFilas(data.reports);
      setFilas(rows);
    } catch (err) {
      console.error('[MisReportes] Error al cargar reportes:', err);
      setFilas([]);
      setError(err.message || 'Error al obtener reportes');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarReportes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalRegistros = useMemo(() => filas.length, [filas]);

  return (
    <div style={{ padding: '0.5rem' }}>
      <div className="d-flex align-items-center mb-3" style={{ gap: '0.75rem', flexWrap: 'wrap' }}>
        <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
          <label className="small mb-0">Fecha</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={fechaConsulta}
            onChange={(e) => setFechaConsulta(e.target.value)}
            style={{ width: '160px' }}
          />
        </div>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={cargarReportes} disabled={cargando}>
          {cargando ? 'Cargando...' : 'Actualizar'}
        </button>
        <div className="text-muted small">Registros: {totalRegistros}</div>
      </div>

      {error && (
        <div className="alert alert-danger py-2">
          {error}
        </div>
      )}

      <div style={{ maxHeight: '60vh', overflow: 'auto', padding: '0.25rem', borderRadius: '8px' }}>
        <table className="table table-sm table-striped table-bordered mb-0">
          <thead className="thead-light">
            <tr>
              <th>N°</th>
              <th>Comprobante</th>
              <th>Cliente</th>
              <th>Fecha Emisión</th>
              <th>Total</th>
              <th>Estado Anterior</th>
              <th>Estado Nuevo</th>
              <th>Fecha Despacho</th>
              <th>Usuario Registro</th>
              <th>Usuario Despacho</th>
            </tr>
          </thead>
          <tbody>
            {filas.length === 0 && !cargando ? (
              <tr>
                <td colSpan="10" className="text-center text-muted">Sin datos</td>
              </tr>
            ) : (
              filas.map((row, index) => (
                <tr key={`${row.IdAuditoria || row.IdDespacho || index}-${index}`}>
                  <td>{row.IdDespacho || '-'}</td>
                  <td>{formatearComprobante(row)}</td>
                  <td>{row.RazonSocial || '-'}</td>
                  <td>{row.FechaEmision ? new Date(row.FechaEmision).toLocaleString('es-PE') : '-'}</td>
                  <td>{row.Total != null ? Number(row.Total).toFixed(2) : '-'}</td>
                  <td>{row.EstadoAnterior || '-'}</td>
                  <td>{row.EstadoNuevo || '-'}</td>
                  <td>{row.FechaDespacho ? new Date(row.FechaDespacho).toLocaleString('es-PE') : '-'}</td>
                  <td>{row.NombreUsuarioRegistro || '-'}</td>
                  <td>{row.NombreUsuarioDespacho || '-'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MisReportes;
